module.exports = __webpack_public_path__ + "img/lose.e749eb9e.png";